/**
 * TID — atproto's timestamp identifier: 13 chars of base32-sortable encoding
 * over (microseconds since epoch << 10 | clockId). Used as the game id: it's
 * the protocol-native record-key format, sortable, unique, and becomes the
 * rkey verbatim if/when the game record itself gets published.
 */
const TID_CHARS = '234567abcdefghijklmnopqrstuvwxyz';

// Per the TID spec: one clockId per process, and timestamps strictly
// monotonic — two calls in the same microsecond must not collide or regress.
const CLOCK_ID = BigInt(Math.floor(Math.random() * 1024));
let lastMicros = 0n;

module.exports.tid = function() {
  const wallMicros = BigInt(Date.now()) * 1000n;
  lastMicros = wallMicros > lastMicros ? wallMicros : lastMicros + 1n;
  let value = (lastMicros << 10n) | CLOCK_ID;
  let out = '';
  for (let i = 0; i < 13; i++) {
    out = TID_CHARS[Number(value & 31n)] + out;
    value >>= 5n;
  }
  return out;
};
